// removed by extract-text-webpack-plugin
module.exports = {"container":"AlexaUnregisterModal-container","wrapper":"AlexaUnregisterModal-wrapper","title":"AlexaUnregisterModal-title","body":"AlexaUnregisterModal-body"};